import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function ChemquoteExportModalFooter({ isFormAcceptable, isBusy, apply }) {
  return (
    <div className="exportModal__footer">
      <Button
        disabled={!isFormAcceptable || isBusy}
        type="button"
        onClick={apply}
        buttonConfig={{
          label: 'Export',
          type: 'primary',
          size: 'sm',
          e2eName: 'export-modal-apply',
          iconOnly: true,
        }}
        iconConfig={{
          name: 'chevron-right',
        }}
      />
    </div>
  );
}

ChemquoteExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  isBusy: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ChemquoteExportModalFooter;
